export default "__VITE_ASSET__BDuSmrPL__"